const textProps = {
  icon: "fas fa-heart",
  color: "lightBlue",
  title: "Message from team",
  description:
    "If everything I did failed - which it doesn't, it actually succeeds - just the fact that I'm willing to fail is an inspiration. People are so scared to lose that they don't even try.",
  link: { href: "#pablo", children: "More details..." },
};
export default textProps;
